import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

function SpinnerButton({ onClick, children, item, className }) {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);
        if (item) {
            await onClick(item);
        } else {
            await onClick();
        }
        setIsLoading(false);
    };

    return (
        <Button className={className} variant="primary" disabled={isLoading} onClick={handleClick}>
            {isLoading ? (
                <>
                    <Spinner animation="border" size="sm" /> Cargando
                </>
            ) : (
                children
            )}
        </Button>
    );
}

export default SpinnerButton;